/**
 * Profile API Service
 * 
 * Handles user profile operations including:
 * - Password changes
 * - Logout
 */

import apiClient from '../client';
import { ApiUrls } from '../urls';

/**
 * Logout user from the system.
 * JWT is sent in Authorization Bearer header by apiClient; no body required.
 * @returns Promise with logout response
 */
export const logoutUser = async (): Promise<any> => {
  const response = await apiClient.post(ApiUrls.logoutUser, {});
  return response.data?.data;
};

/**
 * Change user password
 * @param oldPassword - Current password for verification
 * @param newPassword - New password to set
 * @returns Promise with password change response
 */
export const changeUserPassword = async (
  oldPassword: string,
  newPassword: string
): Promise<any> => {
  const response = await apiClient.post(ApiUrls.changePassword, {
    oldPassword,
    newPassword,
  });
  return response.data?.data;
};
